// Polling helper for the /setup wizard's Verify step, which watches GetSyncStatus
// until the daemon has uploaded its first session.

import type { SyncStatus } from '../types/api';

/** How often (ms) to re-poll sync status while waiting for the first file. */
export const SETUP_POLL_INTERVAL_MS = 3000;

// Poll sync status only while the user has no files yet. int64 fields arrive as
// strings and are omitted by grpc-gateway when zero, so default the absent case.
// Returning a number keeps React Query polling until the first file arrives;
// returning false stops polling once the daemon is connected — never poll on.
export function setupPollInterval(status?: SyncStatus): number | false {
  const totalFiles = parseInt(status?.totalFiles ?? '0', 10);
  return totalFiles > 0 ? false : SETUP_POLL_INTERVAL_MS;
}
